import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const createSmsReturnLink = unaryRpc({
  name: "createSmsReturnLink",
  input: z.object({}),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal("created"),
      merchantPhoneNumber: z.string(),
      smsBody: z.string(),
    }),
    z.object({ status: z.literal("unavailable") }),
  ]),
});
